import { Component } from '@theme/component';
class AlidhaarDiscovery extends Component {
  connectedCallback(){super.connectedCallback();this.initialize();}
  updatedCallback(){super.updatedCallback();this.initialize();}
  disconnectedCallback(){this.controller?.abort();super.disconnectedCallback();}
  initialize(){
    this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
    const track=this.querySelector('[data-perfume-track]');
    this.querySelectorAll('[data-perfume-filter]').forEach(link=>link.addEventListener('click',event=>{
      event.preventDefault();const filter=link.dataset.perfumeFilter;
      this.querySelectorAll('[data-perfume-gender]').forEach(card=>{card.hidden=filter==='featured'?card.dataset.perfumeFeatured!=='true':filter!=='all'&&card.dataset.perfumeGender!==filter;});
      this.querySelectorAll('[data-perfume-filter]').forEach(item=>item===link?item.setAttribute('aria-current','true'):item.removeAttribute('aria-current'));
      track.scrollLeft=0;this.querySelector('[data-discovery-status]').textContent=link.textContent;
    },options));
    this.querySelectorAll('[data-scroll-direction]').forEach(button=>button.addEventListener('click',()=>{track.scrollBy({left:Number(button.dataset.scrollDirection)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},options));
    const controls=this.querySelector('[data-discovery-controls]');if(controls)controls.hidden=false;
  }
}
if(!customElements.get('alidhaar-discovery'))customElements.define('alidhaar-discovery',AlidhaarDiscovery);
